/* ========================================================================== *
 * Created by Iskrzy
 * Index Scripts
 * ========================================================================== */


window.onload = function() {

};

$(document).ready(function($){
    
    //    $('.calypso-slider').slick({
//        prevArrow: '<a class="glyphicon glyphicon-chevron-left prev slick-custom-arrow one no-decoration pointer"></a>',
//        nextArrow: '<a class="glyphicon glyphicon-chevron-right next slick-custom-arrow one no-decoration pointer"></a>',
//        autoplay: true,
//        variableWidth: true,
//        slidesToShow: 1,
//    });

    $('.calypso-slider-no-arrows-no-variableWidth').slick({
        arrows: false,
        autoplay: true,
        variableWidth: false,
        slidesToShow: 1,
        autoplaySpeed: 10000,
    });


    $('.calypso-slider-no-arrows-3').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000,
        variableWidth: true,
        slidesToShow: 4,
    });
    
    
    $('.accepted-cards-one').slick({
            //slide: '',
            //infinite: false, 
            speed: 300,
            autoplaySpeed: 2000,
            arrows: false,
            slidesToShow: 4, 
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
  
              {
                breakpoint: 600, 
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: true,
                }
              },

              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  autoplay: true,
                }
              },
            ] 
          }); 
    
    if($('#fadeslider').length>0){
        $('#fadeslider').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            variableWidth: false,
            adaptiveHeight: false,
            slidesToShow: 1,
            infinity: true,
            speed: 3000,  
            fade: true,
            cssEase: 'linear',
            pauseOnHover:false,
        });
    }
    
    $('.selectpicker-search').selectpicker({});
   
    $('#location').on('change', function(e){
        e.preventDefault();
        if($(this).is(':checked')){
            $('#search-club-id').prop('disabled',true);
            $('#search-club-id').selectpicker('refresh');
             getUserLocation();
             searchAction(1);
            
        } else {
            $('#search-club-id').prop('disabled',false);
            $('#search-club-id').selectpicker('refresh');
            searchAction(1);
            
        }
    });  
    
    $('#search-club-id').on('changed.bs.select', function (e) {
           e.preventDefault();
           if($(this).val()!='')
                searchAction(1);
    });
    
    
    $('.selectpicker-choose-club').on('changed.bs.select', function (e) {
        window.location.href=$(this).val();
    });
    
    if($('#ytplayer').length>0 && $('#ytplayer').is(':visible')){
            if($('#index_video').innerHeight()>$(window).innerHeight()-52){
                $('#index_video').css({ height: $(window).innerHeight()-52, paddingTop: '0px'});
            }
            else 
            $('#index_video').css({ height: 'auto', paddingTop: '56.25%'});
            
     } else { 
            $('#index_video').css({height: 'auto', paddingTop: '0px'});
     }  
     
     
    if($('#mainslider').length>0 && $('#mainslider').is(':visible')){
        if($('#mainslider').innerHeight()>$(window).innerHeight()-52){
            $('#mainslider').css({ height: $(window).innerHeight()-52, paddingTop: '0px'});
        }
        else 
        $('#mainslider').css({ height: 'auto', paddingTop: '56.25%'});
    } else { 
        $('#mainslider').css({height: 'auto', paddingTop: '0px'});
    }  
   
    function findHMPos(){
        var main_header = $('#main-header');
        var header_container = $('.header-container');
        var header_menu = $('.header-menu');
        var totpadd = 0;
        if(main_header.length>0 && header_container.length>0){
           var hc = header_container.outerHeight();
            var mh = main_header.outerHeight();
            var hm = 0;
            if(header_menu.length>0){
               hm = header_menu.outerHeight();
            }
                
            if(hc>0 && mh>0){
                 if(hc>mh){
                   totpadd = (hc-mh)/3;
                   if(hm>0){
                       totpadd = (hc-mh-hm)/3;
                   }
                }
            }
       }

            
       if(totpadd && parseInt(totpadd)>0){
              main_header.css('margin-top', totpadd+'px');
       }
       else main_header.css('margin-top','10px');
   }
    
   function counterStart(){
       var toffset = 500;
            $('.counter').each(function () {
                var c1 = $(this);
                setTimeout(function(){
                     c1.countTo({
                            from: 1,
                            to: parseInt(c1.text().replace(' ', '')),
                            speed: 1000,
                            refreshInterval: 50,
                          });
                }, toffset);
               toffset = toffset+300;
            });
    }
    
    //$('#location').prop('checked',false);
    //$(".search-classes-box").find('input,select').prop('disabled',true);
    
    $(window).resize(function(){
        if($('#ytplayer').length>0 && $('#ytplayer').is(':visible')){
            if($('#index_video').innerHeight()>$(window).innerHeight()-52){
                $('#index_video').css({ height: $(window).innerHeight()-52, paddingTop: '0px'});
            }
            else 
            $('#index_video').css({ height: 'auto', paddingTop: '56.25%'});
        } else { 
               $('#index_video').css({height: 'auto', paddingTop: '0px'});
        }
        
        if($('#mainslider').length>0 && $('#mainslider').is(':visible')){
            if($('#mainslider').innerHeight()>$(window).innerHeight()-52){
                $('#mainslider').css({ height: $(window).innerHeight()-52, paddingTop: '0px'});
            }
            else 
            $('#mainslider').css({ height: 'auto', paddingTop: '56.25%'});
        } else { 
            $('#mainslider').css({height: 'auto', paddingTop: '0px'});
        }  
        
        findHMPos();
    });
          
    $(window).load(function(){
        findHMPos();
    });    

    $(window).on('scroll', function(){
            //animatecounter
            var counter = $('#counters');
            if(counter.length>0){
                if(counter.hasClass('counted'));   
                else {
                    var scrolledToBottom = (window.innerHeight + window.scrollY);
                    if(scrolledToBottom-100>counter.offset().top){
                           counterStart(); 
                           counter.addClass('counted');
                    }
                }
            }
      });
      
      
   
});



